/* @flow */

import type { NETGEM_API_V8_REQUEST_HEADERS } from '../../../../../libs/netgemLibrary/v8/types/Headers';
import type { AppConfigurationState } from '../../../../appConf/reducers';

import { logError } from '../../../../../helpers/debug/debug';
import { HeaderName, HeaderValue } from '../../../../../libs/netgemLibrary/v8/constants/Headers';
import { buildHeaderList } from '../../../../../libs/netgemLibrary/v8/helpers/RequestHeaders';

const buildBOHeaders: (distributorId: string, appConfiguration: AppConfigurationState, extraHeaders?: Array<string>) => NETGEM_API_V8_REQUEST_HEADERS = (
  distributorId,
  appConfiguration,
  extraHeaders,
) => {
  const {
    distributorAppKeys: { [distributorId]: appKey },
  } = appConfiguration;

  if (!appKey) {
    logError(`Missing app key for distributor ${distributorId}`);
  }

  let headersConf = [HeaderName.ContentType, HeaderValue.ApplicationJson, HeaderName.AppKey, appKey];
  if (extraHeaders) {
    headersConf = headersConf.concat(extraHeaders);
  }

  return buildHeaderList(...headersConf);
};

export { buildBOHeaders };
